import React, { FunctionComponent, memo } from "react";
import { Box } from "@mui/material";

import { UserDTO } from "api";
import { getUserRole } from "recoils";
import { capitalizeAllStringWithSeparator, getInitials } from "utils";
import { Avatar, Label10SemiBold, Label12SemiBold } from "components";

export const SelectedUser: FunctionComponent<{
  user?: UserDTO | null;
  onUserSelect?: (user: UserDTO) => void;
}> = memo(({ user, onUserSelect }) => {
  const name = user && user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user && user.email;

  const roles = getUserRole(user && user.roles).map(role => capitalizeAllStringWithSeparator(role, "_")).join(", ");

  return (
    <Box
      sx={{ display: "flex", gap: 2, alignItems: "center", width: "100%" }}
      onClick={onUserSelect && user
        ? (e) => {
          e.stopPropagation();
          onUserSelect(user);
        }
        : undefined
      }
    >
      <Avatar>{getInitials(name || "")}</Avatar>
      <Box>
        <Label12SemiBold>{name}</Label12SemiBold>
        <Label10SemiBold>
          {roles}
        </Label10SemiBold>
      </Box>
    </Box>
  );
});
